module.exports = __webpack_public_path__ + "img/violet_086.05abea24.png";